module.exports = __webpack_public_path__ + "img/dead-grey-trunk-09.eef79b74.png";